import { createProductReaderFromVm } from '../utils/productPricing.js'

/** Shared COGS/margin helpers for ProductsPage, ProductCard, and any list row. */
export default {
  computed: {
    productReader () {
      return createProductReaderFromVm(this)
    }
  },
  methods: {
    readProduct (product) {
      return this.productReader.read(product)
    },
    hasProductCogs (product) {
      return this.productReader.hasCogs(product)
    },
    getProductCogs (product) {
      return this.productReader.getCogs(product)
    },
    getProductMargin (product) {
      return this.productReader.getMargin(product)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/productPricingMixin.js